import React, { useState } from 'react';
import { Form, Icon } from 'semantic-ui-react';
import './password-revealer-input.scss';

const PasswordRevealerInput = (props) => {
  const [isTypePassword, setTypeIsPassword] = useState(true);

  return (
    <Form.Input
      role="textbox"
      {...props}
      className="password-revealer-input"
      type={isTypePassword ? 'password' : 'text'}
      icon={
        <Icon
          role="img"
          inverted
          name="eye"
          link
          onClick={(event) => setTypeIsPassword(!isTypePassword)}
        />
      }
    />
  );
};

export default PasswordRevealerInput;
